/**
 * Vendored POC diagnosis panel (plan 15.2 option B, stage F3). Side-effect imports in the POC's
 * chat4.html script order; each sets one window global (NeoView, DiagMapLayout, DiagMap, NodeGraph,
 * Rhs4Checks, Rhs4Lod, Rhs4LodPick, Rhs4Explain, Rhs4QTurns, Rhs4CauseDetail, Rhs4, V4Pc).
 * The CSS is scoped under .d5-brain (brain-panel.css, generated). Source: learning_brain_poc, commit 6ad5075e.
 */
import "./neo";
import "./diagmap_layout";
import "./diagmap";
import "./nodegraph";
import "./rhs4_checks";
import "./rhs4_lod";
import "./rhs4_lodpick";
import "./rhs4_explain";
import "./rhs4_qturns";
import "./rhs4_causedetail";
import "./rhs4";
import "./chat4_pc";
import "./brain-panel.css";
import "./brain-panel-extras.css";

export { BRAIN_ENDPOINTS, BRAIN_NETWORK_FAILURE, brainGet, configureBrainApi, describeBrainFailure, resetBrainApi } from "./brainApi";

/** The globals the host talks to; null members mean the vendored script did not load. */
export const vendoredPanel = () => ({
  Rhs4: window.Rhs4 || null,
  DiagMap: window.DiagMap || null,
  V4Pc: window.V4Pc || null,
});
